import template   from './navbar.html'
import controller from './navbar.controller'
import './navbar.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/common/navbar/navbar.component.js